export class MapLocationCollection {
  constructor() {
    this._mapLocations = [];
  }

  get empty() {
    return this._mapLocations.length === 0;
  }

  add(mapLocation) {
    this._mapLocations.push(mapLocation);
  }

  find(searchString) {
    if (searchString.trim() === "") {
      return [];
    }
    return this._mapLocations.filter((mapLocation) =>
      matchName(searchString, mapLocation)
    );
  }
}

const matchName = (searchString, namedObject) => {
  return (
    searchableString(namedObject.name).indexOf(searchableString(searchString)) >
    -1
  );
};

const searchableString = (searchString) => {
  return searchString
    .toLowerCase()
    .replace(/[àâä]/g, "a")
    .replace(/[éèêë]/g, "e")
    .replace(/[îï]/g, "i")
    .replace(/[ôö]/g, "o")
    .replace(/[ûùµü]/g, "u")
    .replace(/[^a-z0-9]/g, "")
    .replace(/([a-z])\1+/g, "$1");
};
